<template>
  <div class="sidebar-logo-container" :class="{ 'collapse': collapse }">
    <transition name="sidebarLogoFade">
      <router-link key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo" />
      </router-link>
      <!-- <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img src="../../../assets/sliderbar/logo.png" alt="" class="sidebar-logo">
      </router-link> -->
    </transition>
  </div>
</template>

<script setup>
import logo from '@/assets/sliderbar/logo.png'
// import useSettingsStore from '@/store/modules/settings'
// import variables from '@/assets/styles/theme.module.scss'

defineProps({
  collapse: {
    type: Boolean,
    required: true
  }
})

// const title = import.meta.env.VITE_APP_TITLE;
// const settingsStore = useSettingsStore();
// const sideTheme = computed(() => settingsStore.sideTheme);
</script>

<style lang="scss" scoped>
@use '@/assets/styles/theme.module.scss';

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: var(--el-menu-logo-height);
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  & .sidebar-logo-link {

    & .sidebar-logo {
      width: 147px;
      height: 60px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>